import axios from "axios";
import Cookies from "js-cookie";
import { getTokenCookieBaseOptions } from "./tokenCookieOptions";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  timeout: 30000,
  headers: {},
});

apiClient.interceptors.request.use((config) => {
  const token = getCookie("token");
  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    };
  }

  config.headers = {
    ...config.headers,
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };
  return config;
});

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const errorCode = error?.response?.data?.error?.errorCode;
    const isUnauthorized = status === 401 || errorCode === 401;

    if (isUnauthorized) {
      const pathname = window.location.pathname;
      const isAuthRoute = pathname === "/auth" || pathname.startsWith("/auth/");
      const isAnalysisDemo = pathname === "/analysis-demo";
      const tokenCookieBaseOptions = getTokenCookieBaseOptions();

      if (!isAuthRoute && !isAnalysisDemo) {
        Cookies.remove("token");
        Cookies.remove("token", tokenCookieBaseOptions);
        localStorage.removeItem("userProfile");
        localStorage.setItem("redirect_url", location?.pathname + location?.search);
        window.location.assign("/auth/login");
      }
    }

    return Promise.reject(error?.response?.data ?? error);
  }
);

export default apiClient;

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
